export const DISALLOWED_NAME_CHARACTERS_RE = /[^a-z0-9_ ()\-&<>"'#$%=:@|.]/i
// /[^a-z0-9_ ()\-&#$%:@|.?{^}!~+[\]/:*]/gi // /[^a-z0-9_ ()\-&#$%:@|.]/gi
// removed =, <, >, ', "
const SCRIPT_PATTERNS = [
  /<[a-zA-Z/!]/, // HTML tags: <img, <script, </div
  /j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, // javascript: URI with optional whitespace
  /data\s*:\s*text\/html/i, // data:text/html URI
  /on\w+(?:\s|%09|%0a|%0d|%20)*(?:=|%3d)/i, // HTML event handlers: onload=, onclick= with optional whitespace or URL encoding
  /&#x?[0-9a-fA-F]+;?/, // HTML entity encoding: &#60; &#x3C;
  /%3c|%3e|%3d|%22|%27/i, // URL encoded: %3c = <, %3e = >
  /\\x3c|\\x3e|\\x3d|\\x22|\\x27/i, // JS hex escapes: \x3c (<), \x3e (>), \x3d (=), \x22 ("), \x27 (')
  /\\u003c|\\u003e|\\u003d|\\u0022|\\u0027/i, // JS Unicode escapes: \u003c (<), \u003e (>), \u003d (=), \u0022 ("), \u0027 (')
  /expression\s*\(/i, // CSS expression() injection
  /vbscript\s*:/i, // vbscript: URI (IE legacy)
  /%25[0-9a-fA-F]{2}/i, // double (+ triple) URL encoding: %253c → %3c → <
  /&(?:amp|lt|gt|quot|apos);/i, // named HTML entities used as double-encode step 1
  /autofocus\s*=/i, // autofocus attribute injection
  /srcdoc\s*=/i, // srcdoc attribute injection
  /formaction\s*=/i, // formaction attribute injection
]

export const hasDisallowedNameCharacters = (
  text: string | null | undefined
): boolean => {
  if (typeof text !== 'string') {
    return true
  }

  const normalizeSecurityInput = (value: string) => {
    if (typeof value !== 'string') return ''
    const trimmed = value.trim()
    if (!trimmed) return ''
    try {
      return decodeURIComponent(trimmed)
    } catch {
      return trimmed
    }
  }

  return (
    DISALLOWED_NAME_CHARACTERS_RE.test(text) ||
    SCRIPT_PATTERNS.some((pattern) => {
      const normalizedName = normalizeSecurityInput(text)
      return pattern.test(text) || pattern.test(normalizedName)
    })
  )
}
